































































































































import Super from "@/pv4-super-class"
import { Component } from "vue-property-decorator"

import CodeEditor from "@/components/CodeEditor.vue"
import DataTriggerSelector from "@/components/selectors/DataTriggerSelector.vue"

@Component({
  components: { DataTriggerSelector, CodeEditor }
})
export default class Value extends Super {
  dataScripts: any = null

  mounted() {
    this.load()
  }

  load() {
    this.http
      .get(`/data-scripts?eventID=${this.eventId}`)
      .then(res => (this.dataScripts = res.data))
      .catch(this.displayError)
  }

  createScript() {
    let script = { dataScriptCode: "New Script", eventID: this.eventId }
    this.http
      .post(`/data-scripts?eventID=${this.eventId}`, script)
      .then(this.load)
      .catch(this.displayError)
  }

  saveScript(script) {
    this.http
      .put(
        `/data-script/${script.dataScriptID}?eventID=${this.eventId}`,
        script
      )
      .then(this.load)
      .catch(this.displayError)
  }

  deleteScript(script) {
    this.http
      .delete(`/data-script/${script.dataScriptID}?eventID=${this.eventId}`)
      .then(this.load)
      .catch(this.displayError)
  }
}
